import { Getters } from 'vuex-smart-module';
import { CbcState } from '@/store/cbc/state';

export class CbcGetters extends Getters<CbcState> {
	get phoneType() {
		return this.state.phoneType;
	}

	get CreditScore() {
		return this.state.creditScore;
	}

	get isCbcError() {
		return this.state.isCbcError;
	}

	get isCbcSuccess() {
		return this.state.isCbcSuccess;
	}

	get isLoading() {
		return this.state.isLoading;
	}

	get verificationCodeResponse() {
		return this.state.verificationCodeResponse;
	}

	get verificationCode() {
		return this.state.verificationCodeResponse?.verificationCode;
	}

	get isCreditScoreUpdated() {
		return this.state.isCreditScoreUpdated;
	}

	get cbcSuccessResponse() {
		return this.state.cbcSuccessResponse;
	}

	get showCreditAppLauncher() {
		return this.state.showCreditAppLauncher;
	}

	get addressList() {
		return this.state.addressCount;
	}

	get employmentList() {
		return this.state.employmentCount;
	}

	get isCreditAppFormSubmitted() {
		return this.state.creditAppFormSubmitted;
	}

	get getCreditAppFormFields() {
		return this.state.creditAppFormFields;
	}
}
